import { BetslipType } from '../../../core/betslip-type';
import { LinearModuleType } from '../../linear/linear-module-type';
import { IBaseTypeState } from '../base/state';

/**
 * Gets the active linear betslip types from state
 * @param state The current betslip state
 * @returns The active linear betslip types
 */
export function getLinearBetslipActiveTypes(state: IBaseTypeState): BetslipType[] {
    return [BetslipType.Single, BetslipType.Combo, BetslipType.System, BetslipType.Teaser, BetslipType.BetBuilder].filter(
        (betslipType) => state.linearTypes[betslipType as LinearModuleType],
    );
}
